import { get, patch, post, remove } from 'vio-libs';
export function getKEXProfiles(organization, consumerAPI = false) {
    if (!consumerAPI) {
        return get(`kex-profiles?organization=${organization}`);
    }
    return get(`v1/${organization}/kex/profiles?expand=contacts`, undefined, true);
}
export function getKEXProfile(organization, kexProfileId, consumerAPI = false) {
    if (!consumerAPI) {
        return get(`kex-profiles?organization=${organization}&kex_profile=${kexProfileId}`);
    }
    return get(`v1/${organization}/kex/profiles/${kexProfileId}?expand=contacts`, undefined, true);
}
export function postNewKEXProfile(organization, kexProfile, consumerAPI = false) {
    if (!consumerAPI) {
        return post(`kex-profiles?organization=${organization}`, {
            data: Object.assign({}, kexProfile)
        });
    }
    return post(`v1/${organization}/kex/profiles?expand=contacts`, {
        data: Object.assign({}, kexProfile)
    }, true);
}
export function patchExistingKEXProfile(organization, kexProfileId, update, consumerAPI = false) {
    if (!consumerAPI) {
        return patch(`kex-profiles?organization=${organization}`, {
            data: {
                kex_profile_id: kexProfileId,
                update
            }
        });
    }
    return patch(`v1/${organization}/kex/profiles/${kexProfileId}?expand=contacts`, {
        data: Object.assign({}, update)
    }, true);
}
export function removeKEXProfile(organization, kexProfileId, consumerAPI = false) {
    if (!consumerAPI) {
        return remove(`kex-profiles?organization=${organization}`, {
            data: {
                kex_profile_id: kexProfileId
            }
        });
    }
    return remove(`v1/${organization}/kex/profiles/${kexProfileId}`, undefined, true);
}
